<template>
  <div class="b-card-div">
    <div class="b-card-image" 
      :style="{ backgroundImage: 'url('+ require('../../images/' + url + '.jpg')+')', 
                backgroundPosition: urlPosition }">
    </div>
    <div class="b-card-text-div d-flex flex-column align-start justify-start">
      <h2 class="b-card-head mb-2 py-2 lfTxt paral fw7">{{title}}</h2>
      <div class="b-card-subtitle-div d-flex justify-space-between align-center mb-2">
        <h2 class="b-card-subhead paral fw7">{{subtitle}}</h2>
        <h2 class="b-card-date riTxt paral fw7">{{date}}</h2>
      </div>
      <p class="b-card-text mont fw4 ">{{abstract}}</p>
    </div>
  </div>
</template>
<!--=================================================================================-->
<!--=====================================================================SCRIPTS=====-->
<!--=================================================================================-->
<script>
export default {
  name: "blog-card",
  props: ['url', 'urlPosition','title', 'subtitle', 'abstract', 'date'],
}
</script>
<!--=================================================================================-->
<!--=====================================================================STYLING=====-->
<!--=================================================================================-->
<style>
.b-card-div{
  color: #2F2E2E;
  padding: 0;
  margin: 0;
  width: 100%;
  height: auto;
  transition: all .3s ease-in-out;
  overflow: hidden !important;}
.b-card-div:hover{ 
  color:  #4EA792;  
  transform: scale(1.01);}
.b-card-image{
  background-size: cover;
  width: 100%;
  height: 250px;}
.b-card-text-div{
  height: auto;
  font-size: calc(12px + 0.3vw);
  line-height: calc(15px + 0.3vw);
  overflow: hidden;}
.b-card-head{
  height: auto;
  font-size: 26px;
  line-height: 24px;
  border-top: 4px solid #4EA792;
  border-bottom: 1px solid #8961A0;}
.b-card-subtitle-div{
  height: auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;}
.b-card-subhead{ 
  height: auto;
  width: 70%; 
  font-size: 20px;
  line-height: 18px;}
.b-card-date{ 
  height: auto;
  width: 30%;
  font-size: 18px;
  line-height: 15px;}
</style>